module.exports = __webpack_public_path__ + "static/media/news-under16-registration.3f0de902.png";